"use strict";

require("core-js/modules/es6.array.filter.js");
var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));
var _model = _interopRequireDefault(require("./model"));
var _constants = require("./constants");
function cov_19r1o7064n() {
  var path = "/codebuild/output/src1340795087/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/productList/lib/reducer.js";
  var hash = "f60a67bbf4089318c3ebe9aed8c2b3b8a9e34995";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1340795087/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/productList/lib/reducer.js",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 28
        },
        end: {
          line: 13,
          column: 1
        }
      },
      "1": {
        start: {
          line: 15,
          column: 20
        },
        end: {
          line: 148,
          column: 1
        }
      },
      "2": {
        start: {
          line: 19,
          column: 2
        },
        end: {
          line: 147,
          column: 3
        }
      },
      "3": {
        start: {
          line: 21,
          column: 6
        },
        end: {
          line: 25,
          column: 8
        }
      },
      "4": {
        start: {
          line: 27,
          column: 6
        },
        end: {
          line: 31,
          column: 8
        }
      },
      "5": {
        start: {
          line: 33,
          column: 6
        },
        end: {
          line: 36,
          column: 8
        }
      },
      "6": {
        start: {
          line: 37,
          column: 6
        },
        end: {
          line: 42,
          column: 8
        }
      },
      "7": {
        start: {
          line: 43,
          column: 6
        },
        end: {
          line: 48,
          column: 8
        }
      },
      "8": {
        start: {
          line: 50,
          column: 6
        },
        end: {
          line: 55,
          column: 8
        }
      },
      "9": {
        start: {
          line: 57,
          column: 6
        },
        end: {
          line: 60,
          column: 8
        }
      },
      "10": {
        start: {
          line: 62,
          column: 6
        },
        end: {
          line: 71,
          column: 8
        }
      },
      "11": {
        start: {
          line: 72,
          column: 6
        },
        end: {
          line: 76,
          column: 8
        }
      },
      "12": {
        start: {
          line: 78,
          column: 6
        },
        end: {
          line: 81,
          column: 8
        }
      },
      "13": {
        start: {
          line: 82,
          column: 6
        },
        end: {
          line: 92,
          column: 8
        }
      },
      "14": {
        start: {
          line: 94,
          column: 6
        },
        end: {
          line: 94,
          column: 137
        }
      },
      "15": {
        start: {
          line: 96,
          column: 6
        },
        end: {
          line: 101,
          column: 8
        }
      },
      "16": {
        start: {
          line: 104,
          column: 6
        },
        end: {
          line: 107,
          column: 8
        }
      },
      "17": {
        start: {
          line: 108,
          column: 6
        },
        end: {
          line: 113,
          column: 8
        }
      },
      "18": {
        start: {
          line: 115,
          column: 6
        },
        end: {
          line: 119,
          column: 8
        }
      },
      "19": {
        start: {
          line: 121,
          column: 6
        },
        end: {
          line: 127,
          column: 8
        }
      },
      "20": {
        start: {
          line: 128,
          column: 6
        },
        end: {
          line: 131,
          column: 8
        }
      },
      "21": {
        start: {
          line: 133,
          column: 6
        },
        end: {
          line: 135,
          column: 7
        }
      },
      "22": {
        start: {
          line: 134,
          column: 8
        },
        end: {
          line: 134,
          column: 21
        }
      },
      "23": {
        start: {
          line: 136,
          column: 6
        },
        end: {
          line: 140,
          column: 7
        }
      },
      "24": {
        start: {
          line: 141,
          column: 6
        },
        end: {
          line: 144,
          column: 8
        }
      },
      "25": {
        start: {
          line: 146,
          column: 6
        },
        end: {
          line: 146,
          column: 19
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 15,
            column: 20
          },
          end: {
            line: 15,
            column: 21
          }
        },
        loc: {
          start: {
            line: 15,
            column: 73
          },
          end: {
            line: 148,
            column: 1
          }
        },
        line: 15
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 15,
            column: 21
          },
          end: {
            line: 15,
            column: 60
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 15,
            column: 29
          },
          end: {
            line: 15,
            column: 60
          }
        }],
        line: 15
      },
      "1": {
        loc: {
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 147,
            column: 3
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 20,
            column: 4
          },
          end: {
            line: 25,
            column: 8
          }
        }, {
          start: {
            line: 26,
            column: 4
          },
          end: {
            line: 31,
            column: 8
          }
        }, {
          start: {
            line: 32,
            column: 4
          },
          end: {
            line: 48,
            column: 8
          }
        }, {
          start: {
            line: 49,
            column: 4
          },
          end: {
            line: 55,
            column: 8
          }
        }, {
          start: {
            line: 56,
            column: 4
          },
          end: {
            line: 76,
            column: 8
          }
        }, {
          start: {
            line: 77,
            column: 4
          },
          end: {
            line: 101,
            column: 8
          }
        }, {
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 113,
            column: 8
          }
        }, {
          start: {
            line: 114,
            column: 4
          },
          end: {
            line: 119,
            column: 8
          }
        }, {
          start: {
            line: 120,
            column: 4
          },
          end: {
            line: 131,
            column: 8
          }
        }, {
          start: {
            line: 132,
            column: 4
          },
          end: {
            line: 144,
            column: 8
          }
        }, {
          start: {
            line: 145,
            column: 4
          },
          end: {
            line: 146,
            column: 19
          }
        }],
        line: 19
      },
      "2": {
        loc: {
          start: {
            line: 133,
            column: 6
          },
          end: {
            line: 135,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 133,
            column: 6
          },
          end: {
            line: 135,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 133
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0],
      "1": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "f60a67bbf4089318c3ebe9aed8c2b3b8a9e34995"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_19r1o7064n = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_19r1o7064n();
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var initialState = exports.initialState = (cov_19r1o7064n().s[0]++, {
  tabs: [],
  selectedTabCode: '',
  analyticData: {
    products: [],
    promotions: []
  },
  LOADING: false,
  ERROR: false
});
cov_19r1o7064n().s[1]++;
var productList = function productList() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_19r1o7064n().b[0][0]++, (0, _assign.default)({}, initialState));
  var action = arguments.length > 1 ? arguments[1] : undefined;
  cov_19r1o7064n().f[0]++;
  var tabs;
  var loadingState;
  var analyticData;
  cov_19r1o7064n().s[2]++;
  switch (action.type) {
    case _constants.ProductListActionTypes.PRODUCT_LIST_BEFORE_LOAD:
      cov_19r1o7064n().b[1][0]++;
      cov_19r1o7064n().s[3]++;
      return _objectSpread(_objectSpread({}, state), {}, {
        LOADING: true,
        ERROR: false
      });
    case _constants.ProductListActionTypes.PRODUCT_LIST_BEFORE_LOAD_SUMMARY:
      cov_19r1o7064n().b[1][1]++;
      cov_19r1o7064n().s[4]++;
      return _objectSpread(_objectSpread({}, state), {}, {
        LOADING: true,
        ERROR: false
      });
    case _constants.ProductListActionTypes.PRODUCT_LIST_LOAD_SUMMARY_SUCCESS:
      cov_19r1o7064n().b[1][2]++;
      cov_19r1o7064n().s[5]++;
      loadingState = {
        LOADING: false,
        ERROR: false
      };
      cov_19r1o7064n().s[6]++;
      tabs = _model.default.getProductList(action.tabDatas, action.data, action.seasonHighlighted, action.config);
      cov_19r1o7064n().s[7]++;
      return _objectSpread(_objectSpread(_objectSpread({}, state), loadingState), {}, {
        seasons: action.data.seasons,
        tabs: tabs
      });
    case _constants.ProductListActionTypes.PRODUCT_LIST_CHANGE_TAB:
      cov_19r1o7064n().b[1][3]++;
      cov_19r1o7064n().s[8]++;
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedTabCode: action.selectedTabCode,
        LOADING: true,
        ERROR: false
      });
    case _constants.ProductListActionTypes.PRODUCT_LIST_BEFORE_LOAD_PRODUCTS:
      cov_19r1o7064n().b[1][4]++;
      cov_19r1o7064n().s[9]++;
      loadingState = {
        LOADING: true,
        ERROR: false
      };
      // set state LOADING for section
      cov_19r1o7064n().s[10]++;
      tabs = _model.default.loadProductsIntoSection(state.tabs, action.tabCode, action.sectionCode, action.hasMore, loadingState,
      // section loading
      null, action.config, action.isFilterChanged);
      cov_19r1o7064n().s[11]++;
      return _objectSpread(_objectSpread({}, state), {}, {
        tabs: tabs
      }, loadingState);
    case _constants.ProductListActionTypes.PRODUCT_LIST_LOAD_PRODUCTS_SUCCESS:
      cov_19r1o7064n().b[1][5]++;
      cov_19r1o7064n().s[12]++;
      loadingState = {
        LOADING: false,
        ERROR: false
      };
      cov_19r1o7064n().s[13]++;
      tabs = _model.default.loadProductsIntoSection(state.tabs, action.tabCode, action.sectionCode, action.hasMore, loadingState,
      // section loading
      action.data, action.config, action.filterUpdated, action.generateAllId);
      cov_19r1o7064n().s[14]++;
      analyticData = _model.default.loadPositionOfProduct(state.analyticData, tabs, action.tabCode, action.sectionCode, action.config);
      cov_19r1o7064n().s[15]++;
      return _objectSpread(_objectSpread(_objectSpread({}, state), loadingState), {}, {
        analyticData: analyticData,
        tabs: tabs
      });
    case _constants.ProductListActionTypes.PRODUCT_LIST_CHANGE_FILTER_SUCCESS:
      cov_19r1o7064n().b[1][6]++;
      cov_19r1o7064n().s[16]++;
      // reset analytic data when applied filter
      analyticData = {
        products: [],
        promotions: []
      };
      cov_19r1o7064n().s[17]++;
      return _objectSpread(_objectSpread({}, state), {}, {
        analyticData: analyticData,
        LOADING: true,
        ERROR: false
      });
    case _constants.ProductListActionTypes.PRODUCT_LIST_LOAD_ERROR:
      cov_19r1o7064n().b[1][7]++;
      cov_19r1o7064n().s[18]++;
      return _objectSpread(_objectSpread({}, state), {}, {
        LOADING: false,
        ERROR: true
      });
    case _constants.ProductListActionTypes.PRODUCT_LIST_SELECT_PRODUCT:
      cov_19r1o7064n().b[1][8]++;
      cov_19r1o7064n().s[19]++;
      tabs = _model.default.updateSelectProductIds(state.tabs, action.tabCode, action.sectionCode, action.selectProductId, action.isSelectAll);
      cov_19r1o7064n().s[20]++;
      return _objectSpread(_objectSpread({}, state), {}, {
        tabs: tabs
      });
    case 'GLOBAL_CHANGE_LANGUAGE':
      cov_19r1o7064n().b[1][9]++;
      cov_19r1o7064n().s[21]++;
      if (!state.tabs) {
        cov_19r1o7064n().b[2][0]++;
        cov_19r1o7064n().s[22]++;
        return state;
      } else {
        cov_19r1o7064n().b[2][1]++;
      }
      cov_19r1o7064n().s[23]++;
      tabs = _model.default.changeLanguage(action.language, action.defaultLanguage, state.tabs);
      cov_19r1o7064n().s[24]++;
      return _objectSpread(_objectSpread({}, state), {}, {
        tabs: tabs
      });
    default:
      cov_19r1o7064n().b[1][10]++;
      cov_19r1o7064n().s[25]++;
      return state;
  }
};
var _default = exports.default = productList;